import DownloadIcon from "@mui/icons-material/Download";
import { IconButton, Tooltip } from "@mui/material";
import type { Delivery } from "@types_def/models/delivery.types";
import type { FunctionComponent } from "react";

const AdminInvoiceAction: FunctionComponent = ({ children }) => {
  const { invoice } = children as Delivery;

  if (!invoice) {
    return <i>Error</i>;
  }

  return (
    <Tooltip title="Télécharger">
      <span>
        <IconButton aria-label="Télécharger" color="primary" disabled size="small">
          <DownloadIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default AdminInvoiceAction;
